module.exports = __webpack_public_path__ + "static/media/tarifs.5a032734.xls";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/spr/form/tarifs.xls
// module id = 863
// module chunks = 40